var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-open-download-tool" },
    [
      _c(
        "yxt-dialog",
        {
          ref: "dialog",
          staticClass: "yxtbiz-open-download-tool_dialog",
          attrs: {
            "padding-size": "small",
            visible: _vm.dialogVisible,
            width: "440px",
            "show-close": false,
            "append-to-body": "",
            "destroy-on-close": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleCancel,
          },
        },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-open-download-tool_dialog-title" },
            [
              _c("yxt-svg", {
                attrs: {
                  color: "#F5222D",
                  width: "20px",
                  height: "20px",
                  "icon-class": "message-warning",
                },
              }),
              _c(
                "span",
                { staticClass: "ml12 standard-size-16 text-26 yxtf-weight-5" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.callStatus === "opening"
                          ? _vm.$t("pc_biz_openmili").d("正在打开米粒客户端") +
                              "..."
                          : _vm.$t("pc_biz_openmili_fail").d("未打开米粒客户端")
                      )
                  ),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "mt8 ml32" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.callStatus === "opening"
                    ? _vm
                        .$t("pc_biz_openmili_tip")
                        .d(
                          "若长时间未打开请确认是否安装米粒客户端，若未安装，请下载安装。"
                        )
                    : _vm
                        .$t("pc_biz_openmilifail_tip")
                        .d(
                          "请点击浏览器弹框显示的打开米粒，若未看到浏览器弹框，请点击启动米粒或下载米粒客户端。"
                        )
                ) +
                "\n    "
            ),
          ]),
          _c(
            "div",
            { staticClass: "mt24 yxtbiz-open-download-tool_dialog-footer" },
            [
              _c(
                "yxt-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_comp_messagebox_cancel")))]
              ),
              _vm.callStatus === "fail"
                ? _c("yxt-button", { on: { click: _vm.handleRetry } }, [
                    _vm._v(_vm._s(_vm.$t("pc_biz_startmili").d("启动米粒"))),
                  ])
                : _vm._e(),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleDownload },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_download_mili").d("下载米粒客户端"))
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }